import { render, staticRenderFns } from "./ContentFilterItem.vue?vue&type=template&id=4b34935e&"
import script from "./ContentFilterItem.vue?vue&type=script&lang=js&"
export * from "./ContentFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports